import { get, noop } from "lodash";
import uwtService from "@tvg/api/uwt";

import RG_OPTIONS from "@tvg/types/ResponsibleGaming";
import mediator from "@tvg/mediator";

export const MODULE_NAME = RG_OPTIONS.FUNDING_CONTROLS;

export const MODAL_STATUS = {
  CLOSED: "",
  CONFIRM: "CONFIRM",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
};

export const blockGtmModalOpen = (eventLabel) => {
  mediator.base.dispatch({
    type: "RG_BLOCK_MODAL_OPEN",
    payload: {
      gaEventLabel: eventLabel
    }
  });
};

export const blockGtmHandle = (eventLabel) => {
  mediator.base.dispatch({
    type: "RG_MODAL_CLICK_HANDLE",
    payload: {
      gaEventLabel: eventLabel,
      module: MODULE_NAME
    }
  });
};

/*
  VIWD - Visa Withdrawals should not be considerened for Funding Controls
*/
const parsePaymentMethodData = (method) => ({
  isBlocked:
    get(method, "responsibleIsBlocked", false) ||
    !get(method, "isDepositAvailable", true),
  name: get(method, "paymentType", ""),
  unblockDate: get(method, "responsibleUnblockDate")
});

export const invalidFundingMethods = [
  "IBC",
  "DEBS",
  "CCS",
  "CASH",
  "APPL",
  "VIWD",
  "CASH",
  "OTR",
  "WTRN",
  "CHK"
];

export const validFundingMethod = ({ name }) =>
  !invalidFundingMethods.includes(name);

const fetchPaymentMethods = (
  accountNumber,
  isLogged,
  setActiveMethods,
  setBlockedMethods,
  setError = noop,
  isMZMToggleOn = false
) => {
  if (accountNumber && isLogged) {
    return uwtService
      .getPaymentOptions(accountNumber)
      .then((res) => {
        let parsedMethod = null;
        const parsedActiveMethods = [];
        const parsedBlockedMethods = [];
        get(res, "data", []).forEach((method) => {
          if (!isMZMToggleOn && method.paymentType === "MZM") {
            return;
          }
          parsedMethod = parsePaymentMethodData(method);
          if (parsedMethod && parsedMethod.isBlocked)
            parsedBlockedMethods.push(parsedMethod);
          else if (parsedMethod) parsedActiveMethods.push(parsedMethod);
        });
        setActiveMethods(parsedActiveMethods.filter(validFundingMethod));
        setBlockedMethods(parsedBlockedMethods.filter(validFundingMethod));
      })
      .catch(() => {
        setError(true);
      });
  }

  setActiveMethods([]);
  setBlockedMethods([]);

  return Promise.resolve({});
};

const blockPaymentMethod = (accountNumber, paymentType) =>
  uwtService.blockPaymentMethod(accountNumber, paymentType);

export default {
  fetchPaymentMethods,
  blockPaymentMethod
};
